const btnScrollToTop = document.querySelector("#site-scroll-top");

// scroll to top of page when button clicked
btnScrollToTop.addEventListener("click", e => {
  e.preventDefault();

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
});

// toggle 'scroll to top' based on scroll position
window.addEventListener('scroll', e => {
  btnScrollToTop.style.bottom = window.scrollY > 20 ? '25px' : '-50px';
});

jQuery(function($){
  //opens sub-menus in the footer
  if($(window).width() <= 768) {
    $('.gamma.widget-title').click(function(){
      if($(this).parent().find('> div').css('display') === 'block')
        $(this).parent().find('> div').hide();
      else
        $(this).parent().find('> div').show();
    });
  }
}); 